import * as React from 'react'

import { cn } from '#/shared/lib/utils'

type FormCardVariant = 'default' | 'section'

interface FormCardProps {
  title: React.ReactNode
  actions?: React.ReactNode
  children: React.ReactNode
  className?: string
  contentClassName?: string
  variant?: FormCardVariant
  as?: 'section' | 'form'
  onSubmit?: React.FormEventHandler<HTMLFormElement>
}

const titleClasses: Record<FormCardVariant, string> = {
  default: 'text-base font-semibold text-gray-900',
  section: 'text-xs uppercase text-gray-500',
}

function FormCard({
  title,
  actions,
  children,
  className,
  contentClassName,
  variant = 'default',
  as = 'section',
  onSubmit,
}: FormCardProps) {
  const Container = as
  return (
    <Container
      className={cn(
        'flex w-full flex-col gap-2.5 rounded-md border border-gray-200 bg-white pt-2.5 pb-5',
        className,
      )}
      {...(as === 'form' ? { onSubmit } : {})}
    >
      <header className="flex flex-col gap-1.25">
        <div
          className={cn(
            'flex h-8 items-center justify-between gap-2.5 pb-1.25',
            variant === 'default' && 'px-5',
          )}
        >
          <h3 className={titleClasses[variant]}>{title}</h3>
          {actions ? (
            <div className="flex items-center gap-2.5">{actions}</div>
          ) : null}
        </div>
        {variant === 'default' && <div className="h-px w-full bg-gray-200" />}
      </header>
      <div className={cn('flex flex-col gap-1 px-5', contentClassName)}>
        {children}
      </div>
    </Container>
  )
}

export { FormCard }
export type { FormCardProps, FormCardVariant }
